import React from 'react';
import PropTypes from 'prop-types';

import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons';

import { Button } from 'components/ui/button';
import StageLabel from './stage_label';

export default function Stage({ stage, onClick }) {
  const showCloseProbability = stage.defaultCloseProbability || stage.defaultCloseProbability === 0;
  const value = showCloseProbability ? stage.defaultCloseProbability : '--';

  return (
    <div className="d-flex flex-column gap-1">
      <StageLabel stage={stage} />
      <div className="d-flex gap-2 align-items-center">
        <span>Default Close Probability: {value}%</span>
        <Button icon={faPenToSquare} variant="ghost" onClick={onClick}>
          Edit
        </Button>
      </div>
    </div>
  );
}

Stage.propTypes = {
  stage: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};
